// Libs
// Components, Layouts, Pages
// Others
import { SLATE_700 } from '~/utils/constants/color';
// Styles, images, icons

type Props = {
  fill?: string;
  width?: number | string;
  height?: number | string;
};

const CommonIconArrow = (props: Props) => {
  //#region Destructuring Props
  const { fill = SLATE_700, width = 8, height = 7 } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <svg width={width} height={height} viewBox='0 0 8 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.46222 4.1913C7.50009 4.09989 7.51 3.99929 7.49067 3.90225C7.47134 3.80521 7.42366 3.71608 7.35366 3.64615L4.35366 0.646155C4.30722 0.599667 4.25207 0.562787 4.19138 0.537625C4.13068 0.512463 4.06561 0.499512 3.99991 0.499512C3.9342 0.499512 3.86913 0.512463 3.80844 0.537625C3.74774 0.562787 3.69259 0.599667 3.64616 0.646155L0.646155 3.64615C0.57615 3.71608 0.528466 3.80521 0.509141 3.90225C0.489816 3.99929 0.499718 4.09989 0.537594 4.1913C0.57547 4.28271 0.639618 4.36083 0.721915 4.41577C0.804212 4.4707 0.900958 4.49998 0.999905 4.49991H6.99991C7.09885 4.49998 7.1956 4.4707 7.2779 4.41577C7.36019 4.36083 7.42434 4.28271 7.46222 4.1913Z'
        fill={fill}
      />
    </svg>
  );
};

export default CommonIconArrow;
